import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "../store";

// Components

// Login
import Login from "../views/Login.vue";

// Dashboard
import Dashboard from "../views/Dashboard.vue";

// Main
import Home from "../views/Home.vue";
import Profile from "../views/Profile.vue";
import Calendar from "../views/Calendar.vue";
import Settings from "../views/Settings.vue";

// Tenting
import TentCheck from "../views/TentCheck.vue";

// Admin
import Users from "../views/Users.vue";
import Rosters from "../views/Rosters.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calendar,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tent-check",
    name: "TentCheck",
    component: TentCheck,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/rosters",
    name: "Rosters",
    component: Rosters,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// Ensure user is logged in for pages that require auth
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }

    next("/login");
  } else {
    next();
  }
});

export default router;
